"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _CloseWizardButton = require("./CloseWizardButton");

var _default = _CloseWizardButton.CloseWizardButton;
exports["default"] = _default;